"use client";
import { useI18n } from "@wojo/localization";
import { AlertBanner, Button } from "@wojo/ui";
import { useTripsAndDepartures } from "app/myaccount/_client/hooks";
import dayjs from "dayjs";
import { TripStatus } from "generated/graphql";
import React, { useState } from "react";
import { TripCard } from "../trip-card";
import { TripList } from "../trip-list";
import { WaitlistModal } from "../waitlist-modal";

export const UpcomingTrips: React.FC = () => {
    const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
    const { upcomingTripsAndDepartures } = useTripsAndDepartures();
    const { global } = useI18n("global");
    const l10n = useI18n("account").account;

    if (upcomingTripsAndDepartures.length === 0) {
        return null;
    }

    return (
        <TripList title={l10n.upcoming.l()}>
            {upcomingTripsAndDepartures.map(({ trip, ...rest }) => {
                if (trip?.status === TripStatus.Waitlisted) {
                    return (
                        <React.Fragment key={trip._id}>
                            <AlertBanner
                                title={l10n.onDate.l({
                                    name:
                                        trip.booking?.gcDeparture
                                            ?.micrositeContent?.title ||
                                        trip.departure?.tourContent?.name ||
                                        l10n.tourNameUnavailableLabel.l(),
                                    date: dayjs(trip.departureDate).format(
                                        global.displayDateFormat.l(),
                                    ),
                                })}
                                status="info"
                                showBorder={true}
                                cta={
                                    <Button
                                        variant="quiet"
                                        palette="info"
                                        onClick={() =>
                                            setIsWaitlistModalOpen(true)
                                        }
                                    >
                                        {l10n.moreInfo.l()}
                                    </Button>
                                }
                            >
                                {l10n.youreOnTheWaitList.l()}
                            </AlertBanner>
                            <WaitlistModal
                                isOpen={isWaitlistModalOpen}
                                accessibleTitle={l10n.waitlist.l()}
                                onCloseRequested={() =>
                                    setIsWaitlistModalOpen(false)
                                }
                            />
                        </React.Fragment>
                    );
                }

                return (
                    !trip || <TripCard key={trip._id} trip={trip} {...rest} />
                );
            })}
        </TripList>
    );
};
